module.exports = __webpack_public_path__ + "media/images/mypage/icon/green-pale/ico_seminar_attendee-08190878ae077d8094813c9625804fa6.svg";